import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormControl, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Colors } from 'src/app/utils/enums/colors';
import utils from 'src/app/utils/utils';

@Component({
  selector: 'custom-multi-select-accesor',
  templateUrl: './custom-multi-select-accesor.component.html',
  styleUrls: ['./custom-multi-select-accesor.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(()=> CustomMultiSelectAccesorComponent),
      multi: true
    }
  ]
})
export class CustomMultiSelectAccesorComponent implements OnInit, ControlValueAccessor, OnChanges, OnDestroy {
  disabled: boolean = false;
  subscriptions: Subscription[] = [];
  value = new FormControl<string[]>({value: [], disabled: true});
  @Input() form?: FormGroup;
  @Input() inputName?: string;
  @Input() typeTemplate?: 'none' | 'colors' | 'measurementSystemDetail' = 'none';

  @Input() data!: any;
  @Input() label!: any;
  @Input() optionValue!: string;
  @Input() placeholder?: string;
  @Input() filterBy?: string;
  @Input() dropdownMessage: string = 'Seleccione';
  @Input() isRequired: boolean = false;
  hexadecimal?: string;
  noAplicaId: string = '';
  multiSelectValues!: any;
  dontApply: string = Colors.NO_APLICA_NAME;


  constructor(){
    this.subscriptions.push(
      this.value.valueChanges.subscribe(val => this.propagateChange(val))
    );
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.multiSelectValues = this.data;
  }
  ngOnInit(): void {
    this.multiSelectValues = this.data;
  }

  writeValue(input: any): void {
    this.value.setValue(input ?? [], { emitEvent: false });
  }
  propagateChange: any = (f:any) =>{}
  onTouch: any = () => {}

  registerOnChange(fn: any): void {
    this.subscriptions.push(
      this.value.valueChanges.subscribe(fn)
    );
  }
  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  registerOnTouched(fn: any){
    this.onTouch = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
     if (isDisabled) {
      this.value.disable({ emitEvent: false });
    } else {
      this.value.enable({ emitEvent: false });
    }
  }

  isValidField(){
    return utils.isValidFieldForm(this.form!, this.inputName!)
  }

  errorField(){
    return utils.getFieldErrorForm(this.form!, this.inputName!)
  }

  getCorrectProperty(option: any, optionName: string, last: boolean){
    if(typeof(option) === 'object'){
      return `${option[optionName]}${last ? '' : ','}` ;
    }

    return `${option}${last ? '' : ','}`;
  }

  isOptionDisabled(option: any): boolean {
    const selected = this.value.value || [];
    const noAplicaSelected = selected.includes(this.noAplicaId);
    return noAplicaSelected && option[this.optionValue] !== this.noAplicaId;
  }

}
